export const SCREEN_SIZES = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};
export const BASE_URL = 'https://zown.ca/'

export const buildUrlUsingBase = (path: string) => `${BASE_URL + path}`